import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridRow = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "ms-Grid-row",
    children: props.children
  });
};